import React, {useState, useEffect} from "react";

export default function ClassicoShortsFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M216.019,188.54c2.194-8.028,11.784-50.586-15.04-99.832l-3.435-7.346c0.016-0.099,0.008-0.222-0.055-0.373
     c-1.428-3.613-2.543-7.687-3.506-12.827l-0.345-1.702c-0.285-1.392-0.571-2.848-0.873-4.45c-0.178-0.948-0.397-1.67-0.873-2.102
     c-0.491-0.444-1.202-0.551-2.293-0.349c-25.86,4.859-49.44,10.32-72.088,16.698c-3.058,0.861-6.139,1.706-9.118,2.523
     c-7.326,2.007-14.902,4.085-22.402,6.485c-0.365,0.139-0.611,0.496-0.611,0.892v19.82h-0.012c0.004,0.02,0.004,0.143,0.012,0.349
     v0.071c0.044,1.559,0.194,7.27,0.401,14.576c0.207,7.306,0.46,16.206,0.706,24.139l0.008,0.234
     c-0.286,0.484-0.568,0.972-0.849,1.46c-0.852,1.467-1.698,2.939-2.534,4.411c-1.266,2.221-2.586,4.565-3.923,6.965
     c-1.662,2.983-3.363,6.076-5.057,9.198c-11.875,21.862-20.696,45.466-29.228,68.296c-3.578,9.571-7.278,19.471-11.153,29.109
     c-2.241,5.569-4.232,10.788-6.092,15.949c-1.979,5.493-3.696,10.61-5.247,15.639l-0.285,0.924
     c-1.384,4.486-2.582,8.361-3.729,13.105l-0.222,0.976l0.325,0.076c44.998,10.522,90.642,16.023,91.099,16.079l0.301,0.035
     l0.107-0.48c0.103-0.492,0.238-1.162,0.421-1.943l0.095,0.02c0.19-0.928,0.401-1.864,0.651-2.784
     c0.382-1.228,0.861-2.516,1.46-3.709l0.027,0.004l0.01-0.076c0.99-1.947,2.3-3.628,4.031-4.346l3.233,16.413l0.286-0.016
     c45.454-2.538,95.961-10.241,96.465-10.316l0.293-0.044l-0.016-0.297c-0.004-0.103-0.524-10.372-0.758-16.583
     c-0.036-1.003-0.127-3.054-0.254-5.89c-0.539-12.089-1.662-37.244-1.757-56.552c-0.095-19.713,0.988-45.934,1.353-49.837
     C215.631,190.258,215.789,189.385,216.019,188.54z"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M468.378,247.727c-0.369-15.29-0.714-29.728-0.984-42.257c-0.099-4.597-0.19-9-0.27-13.156
     c-0.182-9.269-0.575-17.952-1.107-26.007h0.004c0-0.008-0.004-0.012-0.008-0.02c-2.352-35.649-7.445-58.971-9.218-66.249
     c-0.892-3.681-1.253-7.54-1.067-11.471c0.282-5.926-0.278-11.669-0.793-15.449c-0.008-0.06-0.785-5.481-1.249-6.842l-0.008-0.012
     c-0.056-0.159-0.103-0.258-0.147-0.286l-0.099-0.06v-0.004l-0.067-0.04l-0.036,0.02c-47.263-9.365-92.331-8.865-121.825-6.794
     c-30.719,2.158-51.376,6.418-53.145,6.79l-0.028-0.015l-0.052,0.032c-0.024,0.008-0.044,0.012-0.048,0.012l0.004,0.016l-0.067,0.04
     c-0.044,0.023-0.095,0.127-0.155,0.29l-0.008,0.023c-0.432,1.278-1.119,5.926-1.126,5.978c-0.488,3.335-1.059,8.456-0.988,13.914
     c0.071,5.914-0.531,11.713-1.793,17.23c-3.903,17.055-8.726,45.978-9.531,86.922c-0.242,12.347-0.563,27.53-0.904,43.602
     c-0.623,29.481-1.328,62.894-1.789,89.805v0.658l0.27,0.048c36.649,6.782,79.909,1.376,88.207,0.226l0.512-0.071v-0.286
     c0-1.65,0.008-3.629,0.02-5.704c0.023-4.645,0.051-9.904-0.024-12.823c1.237-27.776,7.742-56.643,7.806-56.933l0.008-0.06
     c0.623-16.313,3.046-40.651,7.171-40.936c4.062,0.282,6.473,23.849,7.139,40.147c0,0.052-0.004,0.087-0.004,0.095h0.008
     c0.012,0.234,0.02,0.464,0.028,0.694l0.008,0.06c0.067,0.289,6.572,29.156,7.806,56.908c-0.076,3.01-0.048,8.317-0.024,12.998
     c0.012,2.055,0.024,4.018,0.024,5.672v0.282l0.555,0.087c13.152,2.424,27.098,3.24,39.933,3.24c26.42,0,48.131-3.466,48.453-3.518
     l0.274-0.043v-0.726C469.651,300.879,469,273.857,468.378,247.727z"
        />
        <path
          fill="#E2E2E2"
          d="M314.012,203.976v1.416l-49.119-0.175c0.008-0.416,0.016-0.829,0.024-1.241H314.012z"
        />
        <path
          fill="#E2E2E2"
          d="M466.691,205.194l-46.037,0.198c0.008-0.063,0.012-0.119,0.016-0.178c0.032-0.397,0.084-1.043,0.186-1.237
     h45.811C466.675,204.381,466.683,204.785,466.691,205.194"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M467.624,245.349l-40.587,0.159c-0.44-0.583-2.107-2.114-3.716-3.597c-1.138-1.047-2.316-2.13-2.578-2.447
     l-0.115-33.416l46.08-0.198C466.961,217.636,467.283,231.094,467.624,245.349"
        />
        <path
          fill={darkenColor}
          d="M452.797,66.48c-2.578,3.784-9.364,3.768-9.447,3.764l-77.545-0.547l-0.623,0.012l-77.284,0.769
     c-0.067-0.004-6.524-0.19-9.082-4.006c3.288-0.678,23.405-4.645,52.696-6.703C360.89,57.707,405.741,57.203,452.797,66.48"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M314.008,206.047l-0.115,33.416c-0.261,0.317-1.44,1.4-2.578,2.447c-1.61,1.483-3.276,3.014-3.716,3.597
     l-43.551-0.135c0.079-3.855,0.159-7.667,0.238-11.415c0.21-9.844,0.413-19.352,0.591-28.082L314.008,206.047z"
        />
        <polygon
          fill="#E2E2E2"
          points="172.564,210.44 121.259,216.529 121.101,215.124 172.429,209.258 	"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M176.511,244.166c-0.219,0.345-1.186,1.559-2.126,2.733c-1.376,1.721-2.796,3.502-3.154,4.137
     l-40.397,4.779c-0.441-0.559-1.892-1.908-3.304-3.213c-1.023-0.948-2.078-1.928-2.309-2.213l-3.887-33.206l51.304-6.092
     L176.511,244.166z"
        />
        <path
          fill="#E2E2E2"
          d="M209.641,109.351l-33.88,3.403l-0.091-0.912l33.662-3.3C209.435,108.812,209.542,109.081,209.641,109.351"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M217.336,139.364l-31.032,3.106c-0.75-0.547-5.636-4.248-7.516-5.672l-0.004-0.04l-0.04,0.004
     c-0.282-0.21-0.488-0.369-0.599-0.452l-2.32-22.898l34.05-3.419C213.702,120.429,216.027,130.325,217.336,139.364"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M270.203,166.445c0,0-1.525,2.895-3.111,4.085"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M461.32,166.445c0,0,1.525,2.895,3.111,4.085"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M365.81,180.196c0.152-0.047,0.309-0.096,0.469-0.147"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="367.209"
          y1="179.743"
          x2="367.21"
          y2="179.743"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M367.21,179.743c3.423-1.161,7.98-3.098,10.723-5.84c1.821-1.821,2.724-4.271,3.071-6.782c0.351-2.542,0.051-5.047,0.088-7.589
     c0.027-1.86,0.009-3.722,0.013-5.581c0.008-2.961,0.014-5.921,0.021-8.882c0.008-3.445,0.017-6.89,0.025-10.335
     c0.009-3.628,0.017-7.255,0.027-10.882c0.008-3.509,0.017-7.017,0.025-10.526c0.008-3.088,0.015-6.176,0.023-9.264
     c0.005-2.366,0.011-4.732,0.017-7.098c0.003-1.342,0.006-2.685,0.01-4.027c0-0.029,0-0.058,0-0.087"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M381.254,92.849c0-0.164,0.001-0.328,0.001-0.492"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="367.37"
          y1="92.805"
          x2="367.369"
          y2="93.297"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="367.368"
          y1="94.271"
          x2="367.368"
          y2="94.272"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          points="
     367.368,94.272 367.291,179.64 367.291,199.552 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="367.291"
          y1="199.552"
          x2="367.291"
          y2="200.044"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M280.603,67.337c0,0,77.151-15.847,170.264,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          strokeDasharray="0.9836,0.9836"
          d="
     M372.631,234.044c0.44-9.61,1.055-24.379,0.801-26.75c-0.383-3.562-5.209-5.838-7.459-5.166h-0.097
     c-2.25-0.671-7.077,1.604-7.459,5.166c-0.252,2.34,0.344,16.75,0.783,26.364"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          strokeDasharray="0.9836,0.9836"
          d="
     M360.511,223.987v-13.326c0-1.713,0.638-3.382,1.847-4.596c0.831-0.835,1.876-1.286,3.385-1.302"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          strokeDasharray="0.9836,0.9836"
          d="
     M371.295,224.105l-0.185-13.512c0-1.713-0.638-3.382-1.847-4.595c-0.831-0.835-1.876-1.286-3.385-1.302"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="370.067"
          y1="180.179"
          x2="370.067"
          y2="201.215"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M321.152,90.333c14.364,0.219,28.844,0.428,28.851,0.382"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M277.249,89.207l7.172,0.339l8.559,0.347c0,0,5.082,0.082,12.211,0.194"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="321.071"
          y1="72.031"
          x2="350.002"
          y2="71.732"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M278.868,69.997c2.892,1.967,6.404,2.314,6.404,2.314h8.749l11.093-0.115"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M426.046,72.371l10.941,0.055h9.253c0,0,3.492-0.646,6.709-2.082"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M410.078,89.881l-53.814,0.885h-1.274l-0.691-0.802c-0.682-1.249-1.366-2.495-2.032-3.745c-0.886-1.666-1.26-3.595-1.099-5.472
     c0.151-1.756,0.837-3.079,1.692-4.561c0.515-0.891,1.03-1.783,1.544-2.674l0.739-1.346l1.12-0.144l53.814,0.27"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          points="
     454.221,89.429 446.707,89.429 437.565,89.429 425.958,89.62 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M291.562,91.573c-4.518,23.724-10.749,49.345-21.359,74.873l-2.318-1.072"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M439.962,91.573c4.518,23.724,10.749,49.345,21.359,74.873l2.318-1.072"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M423.549,243.876c0.014,17.681,0.014,42.272,0.13,59.943c3.788-0.017-0.006-3.189,0,0c13.766-0.616,30.424-0.22,44.472-0.184"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M466.959,243.855c-12.458-0.148-25.943,0.646-38.239,0.249c-2.38-1.19-3.966-3.57-5.949-5.156c-1.19-10.709,0-21.815-0.408-32.504"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M423.166,210.696c14.28,0.091,28.955,0.091,43.348,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M311.086,246.652c0.1,13.472,0,35.338-0.073,48.258c-0.029,5.109-0.052,9.268-0.057,12.081l-5.226-0.037"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M264.261,243.842l42.327,0.128c0.696-0.691,4.897-4.578,5.577-5.247l0.108-32.278"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="311.469"
          y1="210.696"
          x2="265.058"
          y2="210.696"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="268.088"
          y1="256.004"
          x2="264.014"
          y2="256.004"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          points="
     296.332,256.004 302.885,256.004 302.885,308.726 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M293.864,250.627v37.841c0,0.251-0.24,0.456-0.535,0.456H270.59c-0.295,0-0.535-0.204-0.535-0.456v-37.841"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="270.102"
          y1="291.282"
          x2="270.102"
          y2="308.249"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="293.864"
          y1="291.242"
          x2="293.864"
          y2="308.209"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="310.92"
          y1="71.578"
          x2="310.92"
          y2="92.808"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="314.249"
          y1="71.578"
          x2="314.249"
          y2="92.808"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="415.924"
          y1="71.578"
          x2="415.924"
          y2="92.808"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="419.215"
          y1="71.578"
          x2="419.215"
          y2="92.808"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M262.331,314.527c0,0,33.984,4.934,88.206,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M381.472,314.527c0,0,33.984,4.934,88.206,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M165.646,88.616
     c0.04-0.196,0.061-0.414,0.069-0.637"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          x1="165.661"
          y1="86.713"
          x2="165.661"
          y2="86.709"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2728,1.2676"
          d="
     M165.661,86.709c-0.048-0.449-0.107-0.771-0.107-0.771s-2.655-13.748-3.739-16.476c-0.401-1.009-0.952-1.712-1.484-2.196"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M160.331,67.266
     c-0.17-0.155-0.339-0.287-0.5-0.399"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M167.947,88.631
     c0.042-0.197,0.065-0.413,0.077-0.636"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="0.004,0"
          x1="167.979"
          y1="86.697"
          x2="167.979"
          y2="86.693"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.3041,1.2986,0.004,0"
          d="
     M167.979,86.693c-0.047-0.468-0.107-0.804-0.107-0.804s-2.667-14.07-3.779-16.859c-0.414-1.041-0.99-1.761-1.547-2.254"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M162.546,66.776
     c-0.172-0.152-0.341-0.282-0.504-0.394"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          x1="96.182"
          y1="104.028"
          x2="96.196"
          y2="104.519"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          x1="96.223"
          y1="105.494"
          x2="96.223"
          y2="105.495"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          strokeDasharray="0.9761,0.9749"
          d="
     M96.223,105.495l1.594,57.742c0,0-0.328,12.69-8.485,15.027"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.328"
          strokeMiterlimit="10"
          d="M89.332,178.264
     c-0.156,0.045-0.315,0.086-0.476,0.123"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          points="
     167.336,66.037 171.595,65.195 190.565,61.61 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          points="
     117.708,78.216 131.343,74.333 139.324,72.367 155.838,68.563 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="87.064"
          y1="86.941"
          x2="109.12"
          y2="80.661"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M172.292,83.596l2.08-0.357c0,0,8.675-1.388,20.358-3.354"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M119.697,95.061l13.497-3.609l8.236-1.924c0,0,10.054-2.528,19.742-4.142"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="87.064"
          y1="103.786"
          x2="111.82"
          y2="97.167"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M214.841,188.729l-21.622,2.18c-1.738-1.721-5.107-5.065-6.644-6.595l-4.089-40.214c0.16,0.121,0.313,0.236,0.457,0.344
     c0.395,0.297,0.723,0.544,0.955,0.717c0.12,0.09,0.221,0.165,0.294,0.217c0.727,0.535,1.516,0.765,2.344,0.683
     c0.047-0.004,0.094-0.01,0.14-0.017l30.778-3.081"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M214.594,190.736l-22.101,2.228c-1.507-1.487-6.513-6.456-7.809-7.751l-4.618-45.412c0.664,0.502,1.178,0.89,1.192,0.901
     c1.044,0.789,2.087,1.576,2.87,2.166c0.393,0.295,0.72,0.541,0.95,0.713c0.115,0.086,0.209,0.156,0.275,0.204
     c0.14,0.104,0.495,0.363,0.99,0.314c0.029-0.003,0.057-0.007,0.085-0.012l30.924-3.096"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M216.729,136.478l-29.29,2.932c-1.333-1.002-6.244-4.969-6.244-4.969l-1.863-18.434l31.299-3.142"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M216.865,138.446l-30.288,3.032c-1.154-0.861-4.619-3.483-6.874-5.192l-0.652-0.545l-2.174-21.47l33.815-3.395"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="185.041"
          y1="160.012"
          x2="218.495"
          y2="156.732"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M126.585,95.657
     c0.044,0.209,0.088,0.418,0.132,0.627"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          x1="126.982"
          y1="97.525"
          x2="126.983"
          y2="97.528"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.274,1.2688"
          d="
     M126.983,97.528c5.658,26.157,16.207,56.305,30.539,67.539c0,0,1.388,1.379,3.2,1.759"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M160.723,166.827
     c0.207,0.043,0.418,0.074,0.635,0.088"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M128.172,257.27c1.45,13.394,3.156,27.622,4.68,40.452c0.602,5.074,1.094,9.203,1.417,11.998l35.502-4.255l34.129-3.9l-9.44-82.611
     "
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="177.007"
          y1="238.736"
          x2="195.36"
          y2="236.639"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="176.497"
          y1="234.271"
          x2="194.85"
          y2="232.173"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.2963"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
     193.5,218.522 195.197,219.15 193.583,219.137 195.325,220.17 193.712,220.158 195.431,220.987 193.818,220.975 195.536,221.803 
     193.923,221.792 195.641,222.619 194.029,222.608 195.747,223.435 194.135,223.425 195.852,224.251 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          d="
     M171.088,211.688l3.769,32.237c-0.401,0.529-3.86,4.867-4.447,5.667l-39.011,4.608c-0.625-0.624-4.364-4.109-4.973-4.712
     l-3.749-32.059"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="123.789"
          y1="221.582"
          x2="171.195"
          y2="216.164"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="177.083"
          y1="246.308"
          x2="183.501"
          y2="302.47"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2815,1.2803"
          x1="160.1"
          y1="163.679"
          x2="156.817"
          y2="163.679"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M117.854,100.433
     c-0.094-0.173-0.182-0.373-0.265-0.583"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          x1="117.208"
          y1="98.664"
          x2="117.206"
          y2="98.66"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2498,1.2446"
          d="
     M117.206,98.66c-0.117-0.429-0.184-0.743-0.184-0.743s-2.801-13.529-2.993-16.408c-0.069-1.041,0.05-1.876,0.229-2.517"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M114.26,78.992
     c0.063-0.225,0.134-0.427,0.207-0.605"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M116.012,100.925
     c-0.094-0.173-0.183-0.373-0.265-0.583"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          x1="115.365"
          y1="99.157"
          x2="115.363"
          y2="99.153"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2498,1.2446"
          d="
     M115.363,99.153c-0.117-0.429-0.184-0.743-0.184-0.743s-2.801-13.529-2.992-16.408c-0.069-1.041,0.05-1.876,0.229-2.517"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M112.417,79.485
     c0.063-0.225,0.134-0.427,0.207-0.605"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M214.857,311.579c0,0-0.216,0.031-0.632,0.091
     "
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          x1="212.972"
          y1="311.849"
          x2="212.969"
          y2="311.849"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2716,1.2664"
          d="
     M212.969,311.849c-9.408,1.331-52.402,7.21-93.553,9.506"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M119.413,321.356
     c-0.213,0.012-0.427,0.024-0.64,0.035"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M112.655,318.475c0,0-0.216-0.03-0.633-0.089"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="0.004,0"
          x1="110.754"
          y1="318.204"
          x2="110.751"
          y2="318.204"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          strokeDasharray="1.2871,1.2819,0.004,0"
          d="
     M110.751,318.204c-9.017-1.301-48.644-7.241-88.488-16.625"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4315"
          strokeMiterlimit="10"
          d="M22.259,301.578
     c-0.208-0.049-0.416-0.098-0.624-0.147"
        />
        <path
          fill="#010101"
          d="M216.169,303.423c-0.036-1.003-0.127-3.054-0.254-5.89c-0.539-12.089-1.662-37.244-1.757-56.552
     c-0.095-19.713,0.988-45.934,1.352-49.837c0.084-0.873,0.242-1.745,0.472-2.59c2.194-8.028,11.784-50.586-15.04-99.832
     l-3.435-7.346c0.016-0.099,0.008-0.222-0.055-0.373c-1.428-3.613-2.543-7.687-3.506-12.827l-0.345-1.702
     c-0.285-1.392-0.571-2.848-0.873-4.45c-0.178-0.948-0.397-1.67-0.873-2.102c-0.491-0.444-1.202-0.551-2.293-0.349
     c-25.86,4.859-49.44,10.32-72.088,16.698c-3.058,0.861-6.139,1.706-9.118,2.523c-7.326,2.007-14.902,4.085-22.402,6.485
     c-0.365,0.139-0.611,0.496-0.611,0.892v19.82h-0.012c0.004,0.02,0.004,0.143,0.012,0.349v0.071
     c0.044,1.559,0.194,7.27,0.401,14.576c0.207,7.306,0.46,16.206,0.706,24.139l0.008,0.234c-0.286,0.484-0.568,0.972-0.849,1.46
     c-0.852,1.468-1.698,2.939-2.534,4.411c-1.266,2.221-2.586,4.565-3.923,6.965c-1.662,2.983-3.363,6.076-5.057,9.198
     C62.221,189.256,53.4,212.86,44.868,235.69c-3.578,9.571-7.278,19.471-11.153,29.109c-2.241,5.569-4.232,10.788-6.092,15.949
     c-1.979,5.493-3.696,10.61-5.247,15.639l-0.285,0.924c-1.384,4.486-2.582,8.361-3.729,13.105l-0.222,0.976l0.325,0.076
     c44.998,10.522,90.642,16.023,91.099,16.079l0.301,0.035l0.107-0.48c0.103-0.492,0.238-1.162,0.421-1.943l0.095,0.02
     c0.19-0.928,0.401-1.864,0.651-2.784c1.015-3.264,2.72-6.96,5.529-8.127l3.233,16.413l0.286-0.016
     c45.454-2.538,95.961-10.241,96.465-10.316l0.293-0.044l-0.016-0.297C216.923,319.903,216.403,309.634,216.169,303.423
      M215.348,188.384c-0.238,0.881-0.405,1.789-0.491,2.697c-0.016,0.171-0.032,0.377-0.048,0.607l-22.671,2.285
     c-0.944-0.92-7.607-7.536-8.381-8.317l-4.878-47.957c1.237,0.936,2.931,2.217,2.959,2.237c1.043,0.789,2.086,1.575,2.867,2.166
     c1.099,0.825,1.392,1.047,1.551,1.047c0.028,0,0.048-0.004,0.071-0.016l31.104-3.114
     C220.937,165.038,216.713,183.398,215.348,188.384 M217.336,139.364l-31.033,3.106c-0.749-0.547-5.636-4.248-7.516-5.672
     l-0.004-0.04l-0.039,0.004c-0.282-0.21-0.488-0.369-0.599-0.452l-2.321-22.898l34.051-3.419
     C213.702,120.429,216.027,130.325,217.336,139.364 M209.641,109.351l-33.88,3.403l-0.091-0.913l33.662-3.3
     C209.435,108.811,209.542,109.081,209.641,109.351 M189.683,60.22c0.872-0.163,1.408-0.107,1.733,0.19
     c0.341,0.309,0.516,0.916,0.666,1.733c0.301,1.606,0.587,3.066,0.877,4.462l0.345,1.698c0.96,5.132,2.074,9.218,3.502,12.843
     c-0.202,0.024-0.401,0.052-0.599,0.079c-0.531,0.079-1.063,0.163-1.59,0.25l-0.5,0.079c-0.94,0.151-1.88,0.301-2.816,0.456
     c-1.17,0.19-2.337,0.381-3.502,0.575c-1.353,0.226-2.705,0.448-4.058,0.674c-1.495,0.254-2.994,0.504-4.49,0.758
     c-1.602,0.27-3.201,0.543-4.803,0.817c-0.099,0.016-0.409,0.079-0.714,0.143c-0.297,0.06-0.595,0.119-0.69,0.135l-0.785,0.135
     c-0.155-0.825-2.693-14.203-3.795-16.972c-0.73-1.824-1.96-2.768-2.805-3.229C173.464,63.369,181.457,61.763,189.683,60.22
      M164.58,65.281l-0.004,0.016c0.024,0.004,2.233,0.603,3.276,3.221c1.095,2.741,3.744,16.738,3.768,16.877
     c0.179,0.996,0.262,2.554-0.091,3.082l-8.643,1.69c-0.19,0.036-0.317-0.04-0.325-0.075c0.215-1.091-0.083-2.72-0.099-2.792
     c-0.107-0.559-2.669-13.739-3.744-16.452c-0.773-1.943-2.165-3.074-2.982-3.601C158.658,66.578,161.605,65.924,164.58,65.281
      M117.928,76.827c11.97-3.367,24.21-6.477,36.906-9.376l-0.012,0.028c0.02,0.008,2.273,1.059,3.284,3.609
     c0.956,2.404,3.201,13.727,3.637,15.953l-2.293,0.409c-1.594,0.282-3.189,0.571-4.783,0.861c-3.241,0.587-8.528,1.729-14.148,3.054
     l-5.438,1.273c-4.526,1.115-9.682,2.419-15.318,3.883c-0.682-3.359-2.59-12.855-2.741-15.179
     C116.865,78.977,117.694,77.256,117.928,76.827 M149.599,89.991c4.851,21.303,6.318,33.686,8.349,50.82
     c0.749,6.302,1.594,13.426,2.713,21.894c-17.551-14.537-27.356-55.282-30.097-68.268c1.623-0.409,3.181-0.797,4.672-1.162
     l5.434-1.273C143.86,91.252,146.937,90.558,149.599,89.991 M117.087,77.061c-0.361,0.829-0.849,2.36-0.722,4.323
     c0.194,2.868,2.887,15.901,3.003,16.456c0.012,0.067,0.357,1.67,0.864,2.602c0.024,0.044,0.012,0.087,0,0.111
     c-0.008,0.02-0.036,0.067-0.099,0.083l-6.104,1.261c-0.381-0.409-0.813-1.809-1.011-2.745c-0.028-0.139-2.801-13.541-2.987-16.365
     c-0.155-2.352,0.714-3.716,0.948-4.034C112.998,78.199,115.044,77.632,117.087,77.061 M85.999,86.172
     c0-0.123,0.075-0.238,0.174-0.274c7.469-2.392,15.036-4.466,22.358-6.473c0.504-0.139,1.02-0.278,1.531-0.42
     c-0.373,0.738-0.806,2.015-0.687,3.828c0.167,2.499,2.229,12.7,2.836,15.659c-12.827,3.379-23.957,6.437-26.213,7.06V86.172z
      M116.556,313.525c-3.233,1.333-4.89,4.633-5.922,8.238c-0.67,2.043-1.067,3.954-1.293,5.077c-2.348-0.29-17.888-2.233-38.89-5.763
     c0.313-1.947,6.703-40.746,17.214-64.79l-0.615-0.27c-10.538,24.095-16.936,62.922-17.265,64.944
     c-15.135-2.554-33.028-5.922-50.841-10.074l0.076-0.322c1.138-4.716,2.332-8.583,3.712-13.057l0.286-0.924
     c1.546-5.021,3.264-10.126,5.239-15.611c1.856-5.152,3.847-10.36,6.08-15.921c3.879-9.646,7.584-19.55,11.161-29.129
     c8.524-22.806,17.337-46.386,29.188-68.209c1.694-3.118,3.396-6.211,5.057-9.19c1.337-2.4,2.654-4.74,3.915-6.961
     c0.841-1.471,1.682-2.939,2.534-4.407c0.099-0.175,0.203-0.353,0.305-0.528c0.278,8.766,0.531,16.1,0.686,18.364
     c0.028,0.401,2.813,40.587,6.136,58.356h0.008c0.032,0.163,0.651,4.363-6.124,32.595l0.634,0.151
     c4.51-18.777,5.755-26.995,6.072-30.473l2.689,10.531c0.333,1.313,1.44,5.386,2.971,11.026
     C104.74,266.219,116.762,310.494,116.556,313.525 M120.43,329.993l-3.237-16.44h-0.016c0.028-1.309-0.932-6.164-5.909-25.25
     c-3.634-13.918-8.104-30.394-11.062-41.293c-1.531-5.64-2.637-9.71-2.97-11.018l-3.261-12.764l0.008-0.004
     c-3.316-17.729-6.097-57.872-6.124-58.273c-0.163-2.388-0.44-10.408-0.73-19.8l-1.114-38.925
     c1.808-0.496,13.164-3.621,26.328-7.092c0.016,0.071,0.027,0.127,0.032,0.151c0.095,0.456,0.614,2.737,1.384,3.24l0.111,0.075
     l6.394-1.321c0.246-0.052,0.457-0.218,0.563-0.448c0.107-0.226,0.099-0.484-0.02-0.702c-0.46-0.845-0.797-2.412-0.801-2.423
     c0-0.016-0.043-0.214-0.111-0.543c3.55-0.92,6.905-1.781,10.034-2.566c2.789,13.2,12.807,54.767,30.842,69.05l2.36,46.017
     l-42.756,4.887l0.269,2.384l0.036-0.004c-0.016,0.059-0.02,0.127-0.011,0.194l3.906,33.377c0.008,0.091,0.044,0.178,0.099,0.254
     c0.206,0.282,1.051,1.067,2.412,2.328c1.313,1.214,2.947,2.729,3.269,3.185c0.099,0.135,0.25,0.21,0.408,0.21
     c0.02,0,0.04,0,0.059-0.004l40.567-4.795c0.167-0.02,0.31-0.123,0.389-0.278c0.25-0.5,1.841-2.491,3.118-4.093
     c1.249-1.563,2.027-2.538,2.205-2.856c0.056-0.099,0.076-0.21,0.063-0.321l-2.784-23.782l21.486-2.455
     c1.705,14.227,5.545,48.623,7.845,69.236c0.865,7.762,1.539,13.779,1.837,16.413l-0.067,0.016l-42.464,4.581l-29.664,3.617
     l-0.091-1.162c-0.266-2.312-0.869-7.417-1.662-14.156c-1.412-11.986-3.343-28.402-5.128-43.891l-0.655,0.075
     c1.781,15.488,3.713,31.905,5.124,43.891c0.793,6.739,1.397,11.847,1.658,14.144l0.151,1.84l30.35-3.701l8.437-0.912
     c0.214,1.321,0.567,3.542,0.96,5.985c0.73,4.554,1.555,9.694,1.836,11.348C157.984,327.086,138.803,328.958,120.43,329.993
      M121.259,216.529l-0.158-1.404l51.328-5.866l0.135,1.182L121.259,216.529z M172.639,211.091l3.871,33.075
     c-0.218,0.345-1.186,1.559-2.126,2.733c-1.376,1.721-2.796,3.502-3.153,4.137l-40.397,4.779c-0.441-0.559-1.892-1.908-3.304-3.213
     c-1.023-0.948-2.079-1.928-2.309-2.213l-3.887-33.206L172.639,211.091z M174.987,325.142c-0.277-1.614-1.106-6.79-1.844-11.379
     c-0.384-2.42-0.742-4.625-0.956-5.946l33.397-3.605l0.69-0.147l-0.032-0.301c-0.282-2.46-0.972-8.639-1.872-16.71
     c-2.32-20.772-6.199-55.54-7.885-69.565l-0.04-0.329l-22.14,2.531l-1.031-8.813c-0.008-0.063-0.028-0.127-0.059-0.182l0.036-0.004
     l-0.246-2.158l-9.218,1.055l-2.367-46.124l-0.008-0.147l-0.012-0.012c-1.162-8.77-2.031-16.099-2.796-22.568
     c-2.034-17.154-3.502-29.549-8.365-50.88c1.754-0.369,3.304-0.678,4.546-0.904c1.594-0.29,3.189-0.575,4.783-0.857l2.296-0.409
     c0.071,0.488,0.198,1.551,0.052,2.273c-0.044,0.226,0.027,0.448,0.19,0.611c0.166,0.171,0.416,0.262,0.682,0.262
     c0.071,0,0.147-0.008,0.223-0.024l8.864-1.733L171.945,89c0.603-0.631,0.516-2.209,0.413-3.102l0.798-0.139
     c0.099-0.016,0.404-0.079,0.71-0.139c0.297-0.063,0.599-0.123,0.694-0.139c1.598-0.274,3.201-0.547,4.8-0.817
     c1.499-0.254,2.994-0.504,4.489-0.758c1.353-0.226,2.705-0.448,4.058-0.674c1.166-0.19,2.332-0.385,3.499-0.575
     c0.297-0.047,0.599-0.095,0.896-0.143c0,0.001,0.001,0.002,0.001,0.003c0.168-0.028,0.336-0.052,0.503-0.079
     c0.054-0.009,0.111-0.021,0.168-0.031c-0.001-0.002-0.001-0.003-0.002-0.004l1.249-0.202l0.5-0.079
     c0.528-0.083,1.055-0.171,1.583-0.246c0.223-0.032,0.448-0.063,0.674-0.087l3.384,7.231c3.502,6.429,6.374,12.744,8.729,18.88
     l-7.943,0.777c-0.075,0.023-0.158,0.025-0.236,0.028c-0.036,0.001-0.073,0.002-0.11,0.006c-0.019,0.002-0.039,0.003-0.057,0.007
     c0.058-0.011-0.008,0.001-0.02,0.003c-0.089,0.012-0.179,0.027-0.27,0.024c-0.002,0-0.004-0.001-0.007-0.001c0,0,0,0.001,0,0.001
     l-25.499,2.503l0.155,1.571h-0.004l2.412,23.826l0.095,0.087c0.016,0.012,0.23,0.175,0.551,0.42l4.95,48.683l0.015,0.067
     c0.032,0.099,8.627,8.659,8.758,8.718l0.084,0.04l22.798-2.301c-0.468,6.973-1.341,31.171-1.257,48.627
     c0.095,19.324,1.218,44.486,1.757,56.575c0.127,2.836,0.218,4.887,0.253,5.886c0.211,5.621,0.654,14.56,0.746,16.298
     C213.853,320.105,197.068,322.608,174.987,325.142"
        />
        <path
          fill="#010101"
          d="M468.341,247.741c-0.369-15.29-0.714-29.728-0.984-42.257c-0.099-4.597-0.19-9-0.27-13.156
     c-0.182-9.269-0.575-17.952-1.107-26.007h0.004c0-0.008-0.004-0.012-0.008-0.02c-2.352-35.649-7.445-58.971-9.218-66.249
     c-0.892-3.681-1.253-7.54-1.067-11.471c0.282-5.926-0.278-11.669-0.793-15.449c-0.008-0.059-0.785-5.481-1.249-6.842l-0.008-0.012
     c-0.056-0.159-0.103-0.258-0.147-0.286l-0.099-0.059v-0.004l-0.067-0.04l-0.036,0.02c-47.263-9.364-92.331-8.865-121.825-6.794
     c-30.719,2.158-51.376,6.417-53.145,6.79l-0.028-0.015l-0.052,0.032c-0.024,0.008-0.044,0.012-0.048,0.012l0.004,0.016l-0.067,0.04
     c-0.044,0.023-0.095,0.127-0.155,0.29l-0.008,0.023c-0.432,1.278-1.118,5.926-1.126,5.978c-0.488,3.335-1.059,8.456-0.988,13.914
     c0.071,5.914-0.531,11.713-1.793,17.23c-3.903,17.055-8.726,45.978-9.531,86.922c-0.242,12.347-0.563,27.53-0.904,43.602
     c-0.623,29.481-1.328,62.894-1.789,89.805v0.658l0.27,0.048c36.649,6.782,79.909,1.376,88.207,0.226l0.512-0.071v-0.286
     c0-1.65,0.008-3.629,0.02-5.704c0.023-4.645,0.051-9.904-0.024-12.823c1.237-27.776,7.742-56.643,7.806-56.932l0.008-0.059
     c0.623-16.313,3.046-40.651,7.171-40.936c4.061,0.282,6.473,23.849,7.139,40.147c0,0.052-0.004,0.087-0.004,0.095h0.008
     c0.012,0.234,0.02,0.464,0.028,0.694l0.008,0.059c0.067,0.289,6.572,29.156,7.806,56.908c-0.076,3.01-0.048,8.317-0.024,12.998
     c0.012,2.055,0.024,4.018,0.024,5.672v0.282l0.555,0.087c13.152,2.424,27.098,3.24,39.933,3.24c26.42,0,48.131-3.466,48.453-3.518
     l0.274-0.043v-0.726C469.615,300.893,468.964,273.871,468.341,247.741 M467.623,245.349l-40.587,0.159
     c-0.44-0.583-2.106-2.114-3.716-3.598c-1.138-1.047-2.316-2.13-2.578-2.447l-0.115-33.416l46.081-0.198
     C466.961,217.636,467.282,231.094,467.623,245.349 M466.691,205.194l-46.037,0.198c0.008-0.064,0.012-0.119,0.016-0.179
     c0.032-0.397,0.083-1.043,0.186-1.237h45.811C466.675,204.381,466.683,204.786,466.691,205.194 M456.121,100.205
     c1.733,7.131,6.659,29.68,9.063,64.159c-0.052-0.135-0.111-0.27-0.163-0.405c-0.115-0.282-0.226-0.563-0.341-0.841
     c-0.194-0.488-0.389-0.976-0.579-1.464c-0.147-0.373-0.293-0.742-0.44-1.118c-0.123-0.313-0.242-0.631-0.365-0.944
     c-7.532-19.554-13.64-41.837-18.606-67.847l1.206-0.024c4.549-0.063,8.274-0.091,9.103-0.099
     C455.07,94.553,455.443,97.429,456.121,100.205 M455.034,88.549c-0.036,0.809-0.048,1.614-0.04,2.419
     c-0.837,0.008-4.557,0.036-9.107,0.099l-6.362,0.115c-3.946,0.06-8.464,0.123-13.339,0.195V70.784l17.158,0.123
     c0.313,0.004,6.973,0.024,9.84-3.828C453.773,69.685,455.491,79.014,455.034,88.549 M331.512,59.769
     c29.378-2.062,74.229-2.566,121.286,6.711c-2.578,3.784-9.364,3.768-9.448,3.764l-77.545-0.547l-0.623,0.012l-77.284,0.769
     c-0.067-0.004-6.525-0.19-9.083-4.006C282.103,65.794,302.22,61.828,331.512,59.769 M425.525,70.78v22.465
     c0,0.385-0.313,0.698-0.698,0.698h-13.85c-0.385,0-0.698-0.313-0.698-0.698V70.672L425.525,70.78z M349.598,86.371
     c0.567,1.067,1.151,2.13,1.729,3.193c0.527,0.968,1.055,1.936,1.575,2.907c-8.956,0.008-19.53-0.103-31.615-0.337V70.804
     l32.107-0.317l-3.197,5.537c-0.857,1.479-1.575,2.86-1.733,4.696C348.297,82.67,348.698,84.682,349.598,86.371 M320.624,70.811
     v22.433c0,0.385-0.313,0.698-0.698,0.698h-13.85c-0.385,0-0.698-0.313-0.698-0.698V70.962L320.624,70.811z M274.706,103.573
     c1.273-5.573,1.884-11.423,1.809-17.388c-0.107-8.694,1.384-16.718,1.92-19.102c2.832,3.863,9.166,4.046,9.46,4.054l16.821-0.167
     v20.796c-4.756-0.119-9.158-0.238-12.994-0.349l-6.136-0.234c-4.954-0.154-9.095-0.214-9.134-0.214l-0.008,0.654
     c0.04,0,4.173,0.06,9.123,0.218l1.237,0.043c-4.962,25.968-11.062,48.215-18.59,67.745c-0.115,0.297-0.23,0.599-0.345,0.896
     c-0.151,0.385-0.301,0.761-0.448,1.142c-0.19,0.48-0.381,0.96-0.571,1.436c-0.115,0.29-0.23,0.575-0.345,0.86
     c-0.067,0.167-0.138,0.334-0.206,0.5C268.13,137.021,271.691,116.745,274.706,103.573 M264.917,203.976h49.095v1.416l-49.119-0.175
     C264.901,204.801,264.909,204.389,264.917,203.976 M264.286,233.958c0.21-9.844,0.413-19.352,0.591-28.082l49.13,0.171
     l-0.115,33.416c-0.262,0.317-1.44,1.4-2.578,2.447c-1.61,1.484-3.276,3.015-3.716,3.598l-43.55-0.135
     C264.128,241.518,264.207,237.706,264.286,233.958 M264.033,246.027l43.606,0.135h0.004c0.186,0,0.357-0.088,0.46-0.234
     c0.341-0.484,2.181-2.178,3.657-3.534c0.318-0.294,0.607-0.555,0.873-0.805c-0.016,14.703-0.059,33.956-0.091,48.072
     c-0.024,9.21-0.04,16.44-0.04,19.252l-16.524-0.099v-19.796c0.048-0.174,0.079-0.361,0.079-0.551v-33.722h8.143v53.982h0.654
     V254.09h-8.797v-5.378h-28.193v5.378h-4.002C263.922,251.386,263.977,248.697,264.033,246.027 M293.328,290.184h-22.739
     c-1.142,0-2.07-0.769-2.07-1.717v-39.1h26.88v39.1C295.398,289.414,294.47,290.184,293.328,290.184 M295.323,290.081v18.729
     l-20.744-0.127l-5.787,0.024v-18.463c0.48,0.369,1.107,0.595,1.797,0.595h22.739C294.117,290.839,294.823,290.545,295.323,290.081
      M263.85,254.745h4.014v33.722c0,0.369,0.099,0.718,0.27,1.027v19.217l-5.366,0.023C263.085,291.64,263.469,272.927,263.85,254.745
      M365.479,207.261c-4.565,1.217-6.489,23.619-7.179,35.157c-0.504-10.669-1.495-32.881-1.154-36.046
     c0.246-2.285,2.051-3.804,3.11-4.506c1.757-1.166,3.875-1.729,5.224-1.4V207.261z M365.479,199.792
     c-1.531-0.301-3.724,0.29-5.589,1.531c-1.987,1.32-3.193,3.089-3.399,4.978c-0.452,4.216,1.349,40.31,1.428,41.845l0.087-0.004
     c-0.012,0.242-0.019,0.453-0.028,0.611c-0.246,1.091-6.592,29.581-7.814,57.04c0.075,2.931,0.048,8.19,0.024,12.827
     c-0.012,1.956-0.02,3.828-0.024,5.418c-8.405,1.166-51.261,6.496-87.667-0.179v-0.103c0.079-4.613,0.166-9.416,0.257-14.358
     l11.82-0.052l38.588,0.234v-0.333c0-2.534,0.016-9.983,0.04-19.585c0.032-14.314,0.075-33.912,0.091-48.687
     c0.627-0.587,1.027-0.98,1.158-1.163c0.063-0.083,0.095-0.186,0.099-0.293l0.115-33.607c0-0.067-0.016-0.131-0.04-0.19h0.04v-2.4
     h-49.738c0.095-4.577,0.182-8.924,0.262-12.966c0.167-8.464,0.508-16.404,0.976-23.841c0.317-0.762,0.63-1.527,0.94-2.297
     c0.119-0.294,0.238-0.587,0.357-0.884c0.186-0.464,0.373-0.936,0.559-1.404c0.155-0.393,0.309-0.789,0.46-1.182
     c0.111-0.278,0.218-0.555,0.325-0.833c9.975-25.841,15.385-50.852,18.661-68.002l4.228,0.159c3.847,0.111,8.254,0.23,13.017,0.353
     v0.821c0,0.75,0.611,1.36,1.36,1.36h13.85c0.75,0,1.36-0.611,1.36-1.36v-0.452c11.689,0.222,21.969,0.337,30.735,0.337
     c4.982,0,9.472-0.04,13.458-0.111V199.792z M365.804,92.356c-3.629,0.067-7.691,0.107-12.157,0.115
     c-0.575-1.078-1.158-2.149-1.745-3.22c-0.579-1.063-1.158-2.122-1.725-3.185c-0.841-1.583-1.218-3.463-1.063-5.291
     c0.147-1.702,0.837-3.01,1.65-4.426l3.391-5.87l11.034-0.107l0.619-0.016l43.808,0.313v20.958
     C391.554,91.904,376.815,92.15,365.804,92.356 M366.141,207.261v-6.818c1.349-0.278,3.411,0.286,5.124,1.424
     c1.055,0.702,2.86,2.221,3.106,4.506c0.333,3.074-0.591,24.135-1.107,35.114C372.527,229.713,370.584,208.447,366.141,207.261
      M469.349,323.93c-3.974,0.615-49.373,7.333-87.89,0.234l-0.008-0.004c0-1.594-0.012-3.451-0.02-5.391
     c-0.028-4.676-0.056-9.979,0.02-13.001c-1.218-27.435-7.568-55.925-7.814-57.016c-0.008-0.194-0.016-0.456-0.032-0.773
     c0.151-3.018,1.86-37.557,1.42-41.678c-0.206-1.888-1.412-3.657-3.399-4.978c-1.825-1.214-3.958-1.805-5.485-1.547V93.007
     c10.971-0.206,25.591-0.448,43.475-0.726v0.964c0,0.75,0.607,1.36,1.36,1.36h13.85c0.75,0,1.36-0.611,1.36-1.36v-1.21
     c4.879-0.075,9.4-0.139,13.351-0.194l4.49-0.083c3.268,17.146,8.678,42.217,18.673,68.117c0.115,0.297,0.23,0.595,0.345,0.888
     c0.147,0.385,0.301,0.769,0.452,1.154c0.186,0.476,0.377,0.952,0.567,1.428c0.115,0.29,0.234,0.579,0.349,0.869
     c0.301,0.746,0.607,1.487,0.912,2.225c0.528,8.024,0.92,16.67,1.099,25.9c0.071,3.499,0.147,7.168,0.226,10.983h-45.866
     c-0.623,0-0.69,0.853-0.769,1.837c-0.012,0.182-0.028,0.361-0.044,0.528l0.052,0.004c-0.032,0.067-0.052,0.143-0.052,0.222
     l0.115,33.607c0,0.103,0.032,0.206,0.095,0.29c0.131,0.182,0.531,0.579,1.158,1.166c-0.063,14.021-0.131,41.119,0.131,65.099
     l0.02,1.622l0.535-1.293c6.679-0.04,14.013-0.064,21.109-0.087c8.694-0.028,17.686-0.056,25.769-0.119l-0.008-0.662
     c-8.079,0.063-17.067,0.091-25.761,0.119c-7.056,0.023-14.35,0.048-21.002,0.087v-0.064c0.02-0.512,0.036-1.277,0.004-1.781v-0.246
     h-0.024c0-0.012-0.004-0.024-0.004-0.032c-0.23-23.013-0.171-48.338-0.107-62.029c0.266,0.246,0.555,0.511,0.873,0.805
     c1.479,1.36,3.316,3.05,3.657,3.534c0.103,0.146,0.274,0.234,0.464,0.234l40.643-0.155c0.012,0.583,0.028,1.162,0.04,1.749
     c0.627,26.13,1.273,53.148,1.67,76.014V323.93z"
        />
        <path
          fill="#010101"
          d="M89.819,89.388c-1.182,0-2.074,1.932-2.074,4.494c0,2.558,0.892,4.49,2.074,4.49
     c1.182,0,2.074-1.932,2.074-4.49C91.893,91.32,91,89.388,89.819,89.388z"
        />
        <path
          fill="#010101"
          d="M99.072,86.612c-1.182,0-2.074,1.932-2.074,4.494c0,2.562,0.892,4.49,2.074,4.49
     c1.182,0,2.074-1.928,2.074-4.49C101.146,88.544,100.254,86.612,99.072,86.612z"
        />
        <path
          fill="#010101"
          d="M359.823,77.209c-1.825,0-3.312,1.487-3.312,3.316c0,1.825,1.487,3.312,3.312,3.312
     c1.828,0,3.315-1.487,3.315-3.312C363.139,78.696,361.651,77.209,359.823,77.209z"
        />
        <path
          fill="#010101"
          d="M374.78,77.209c-1.828,0-3.316,1.487-3.316,3.316c0,1.825,1.487,3.312,3.316,3.312
     c1.828,0,3.315-1.487,3.315-3.312C378.096,78.696,376.608,77.209,374.78,77.209z"
        />
      </g>
    </svg>
  );
}
